(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll('.hero').forEach(hero => {
      const video = hero.querySelector('video'), button = hero.querySelector('.video-toggle');
      if (!video || !button || button.dataset.ready) return;
      button.dataset.ready = 'true';
      const sync = () => { button.textContent = video.paused ? (button.dataset.playLabel || 'Play video') : (button.dataset.pauseLabel || 'Pause video'); button.setAttribute('aria-label', video.paused ? 'Play background video' : 'Pause background video'); };
      button.addEventListener('click', () => video.paused ? video.play().catch(sync) : video.pause());
      video.addEventListener('play', sync); video.addEventListener('pause', sync);
      if (!reduced.matches && hero.dataset.autoplay !== 'false') video.play().catch(sync);
      sync();
    });
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      gallery.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
        const main = gallery.querySelector('.gallery-main');
        if (!main) return;
        main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = button.dataset.image;
        main.alt = button.dataset.alt || button.getAttribute('aria-label') || 'Marian bunny';
        gallery.querySelectorAll('[data-image]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      }));
    });
    root.querySelectorAll('.occasion-list details').forEach(detail => {
      if (detail.dataset.ready) return;
      detail.dataset.ready = 'true';
      detail.addEventListener('toggle', () => { if (detail.open && detail.parentElement.dataset.singleOpen !== 'false') detail.parentElement.querySelectorAll('details').forEach(other => {if (other !== detail) other.open = false;}); });
    });
    if ('IntersectionObserver' in window && !reduced.matches && document.body.dataset.animation !== 'false') {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold: .12 });
      root.querySelectorAll('.reveal:not(.is-visible)').forEach(element => observer.observe(element));
    }
    root.querySelectorAll('.mobile-nav a').forEach(link => link.addEventListener('click', () => { const menu = link.closest('details'); if (menu) menu.open = false; }));
    root.querySelectorAll('[data-product-section]').forEach(product => {
      const select = product.querySelector('[data-variant-select]');
      if (!select || select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const price = product.querySelector('[data-current-price]'), compare = product.querySelector('[data-compare-price]'), add = product.querySelector('[data-add-button]');
        if (price) price.textContent = option.dataset.price;
        if (compare) { compare.textContent = option.dataset.compare; compare.hidden = Number(option.dataset.compareNumber) <= Number(option.dataset.priceNumber); }
        if (add) { add.disabled = option.dataset.available !== 'true'; add.textContent = add.disabled ? add.dataset.soldOutLabel : add.dataset.addLabel; }
        const sku = product.querySelector('[data-current-sku]'), skuRow = product.querySelector('[data-product-sku]');
        if (sku) sku.textContent = option.dataset.sku || '';
        if (skuRow) skuRow.hidden = !option.dataset.sku;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });
    });
  }
  if (document.body.dataset.smoothScroll === 'false') document.documentElement.style.scrollBehavior = 'auto';
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.mobile-nav[open]').forEach(menu => menu.open = false); });
  reduced.addEventListener('change', () => { if (reduced.matches) document.querySelectorAll('.hero video').forEach(v => v.pause()); });
  const dialog = document.getElementById('product-dialog');
  if (dialog) {
    let opener;
    document.querySelectorAll('a[href="#product"]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); opener = link; dialog.showModal(); document.body.style.overflow = 'hidden'; }));
    const close = () => dialog.close();
    dialog.querySelectorAll('.dialog-close,.dialog-return').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); } });
    dialog.addEventListener('close', () => { document.body.style.overflow = ''; if (opener) opener.focus(); });
  }
})();
